import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="mb-4 text-9xl font-bold text-black">404</h1>
        <p className="mb-4 text-xl text-gray-600">Oops! Page not found</p>
        <p><img src="https://ik.imagekit.io/4apzi8lz0/unsupported-404.svg?updatedAt=1760919144486" className="items-center justify-center mx-auto" /></p>
        <p className="mb-8 text-gray-500">
          The page you are looking for does not exist or has been moved.
        </p>
        <a href="/" className="text-blue-500 underline hover:text-blue-700">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
